import { gql } from '@apollo/client';

export const GET_TT_PRESORT_OPTIONS = gql`
    query GetTtPresortOptions($carrierCode: Int!, $nextStopCodes: [String!], $fromCode: String, $ttBizTypes: [String!]) {
        getTtPresortOptions(carrierCode: $carrierCode, nextStopCodes: $nextStopCodes, fromCode: $fromCode, ttBizTypes: $ttBizTypes) {
            nextStopCode
            carrierCode
            ttBizType
            presortCode
            mappedSortingCode
        }
    }
`;

export interface TtPresortOption {
    nextStopCode: string;
    carrierCode: number;
    /** 归属业务类型（FBT/CBT/UNLIMITED） */
    ttBizType: string;
    /** 预分拣码（含尾程商前缀，如 UNI_SEA01） */
    presortCode: string;
    /** 对应尾程三段码（仅 SWX 行） */
    mappedSortingCode?: string | null;
}

export interface GetTtPresortOptionsResponse {
    getTtPresortOptions: TtPresortOption[];
}
